import { render, staticRenderFns } from "./CustomToastV2.vue?vue&type=template&id=72ef3b48"
import script from "./CustomToastV2.vue?vue&type=script&lang=js"
export * from "./CustomToastV2.vue?vue&type=script&lang=js"
import style0 from "./CustomToastV2.vue?vue&type=style&index=0&id=72ef3b48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports